import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const ProtectedRoutes = ({ children, allowedRoles }) => {
  const { authData, isAuthChecked } = useAuth();

  // Verifie si L'authentification a ete verifié avant de verifier celle-ci
  if (!isAuthChecked) {
    return <div>Loading...</div>;
  }

  if (!authData.isLoggedIn || !allowedRoles.includes(authData.role)) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoutes;
